


import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { IRecipient } from '@/entities/notices'
import { SuggestionView, SuggestionComment, SuggestionCommentNew } from '@/entities/suggestions'

@Component<SuggestionDetailBase>({
    components: {
    }
})
export default class SuggestionDetailBase extends Vue {
    @Prop(String) public id!: string // from the route

    @Getter public getUserId!: number
    @Getter public getUserIsAdmin!: boolean
    @Getter public suggestionView?: SuggestionView
    @Getter public suggestionComments?: SuggestionComment[]
    @Getter public suggestionMentionUsers!: IRecipient[]

    @Action public setSuggestionComments
    @Action public createSuggestionSeen!: (suggestionId: number) => void
    @Action public createSuggestionComment!: (
        comment: SuggestionCommentNew
    ) => Promise<SuggestionComment>
    @Action public loadSuggestionMentionUsers

    public mounted() {
        if (!this.suggestionMentionUsers || !this.suggestionMentionUsers.length) {
            this.loadSuggestionMentionUsers()
        }
    }

    public get suggestion() {
        return this.suggestionView
    }

    public get suggestionId() {
        if (this.suggestionView) {
            return this.suggestionView.id
        }

        return parseInt(this.id, 10)
    }

    public get canDelete() {
        return (
            this.suggestionView &&
            (this.suggestionView.user_id === this.getUserId ||
                this.getUserIsAdmin)
        )
    }

    public get hasBeenActioned() {
        return !!(this.suggestion && this.suggestion.actioning_suggestioncomment_id)
    }

    public get showActionButtons() {
        return (
            this.getUserIsAdmin &&
            this.suggestion &&
            !this.hasBeenActioned
        )
    }

    public get actioningComment(): SuggestionComment | false {
        if (!this.suggestionComments) {
            return false
        }
        return this.suggestionComments.find(({ action }) => !!action) || false
    }

    public get displayComments() {

        if (!this.suggestionComments) {
            return []
        }

        return this.suggestionComments
            .filter(({ action }) => !action)
            .slice()
            .sort((a, b) => a.created - b.created)
    }

    public async handleCreateComment(text: string, mentions: IRecipient[]) {
        const body = text.trim()
        if (body === '') {
            return
        }

        await this.createSuggestionComment({
            body,
            suggestion_id: this.suggestionId,
            mentions
        })

        await this.setSuggestionComments(this.suggestionId)

        const anchor = this.$refs.commentsEnd as Element
        if (anchor) {
            anchor.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        }
    }
}
